import {
  GSMServiceKind,
  serviceKindLabel,
} from "@/services/backend/services/types/kinds";
import {
  OfferSetupChoice,
  OfferSetupDropdownConfig,
} from "../offer/components/offer-setup-dropdown";
import { wrhOfferSetupChoices } from "./wrh-offer-setup-dropdown-config";

/**
 * omniOfferServiceKinds are the service kinds an offer of an omni process
 * may have, see `offer.ServiceKinds`,
 * backend/core/omni/domain/offer/service_kinds.go.
 */
export const omniOfferServiceKinds: GSMServiceKind[] = [
  GSMServiceKind.VBS,
  GSMServiceKind.RLT,
  GSMServiceKind.HTZ,
  GSMServiceKind.SHS,
  GSMServiceKind.WRH,
  GSMServiceKind.KHS,
  GSMServiceKind.TWH,
  GSMServiceKind.VDK,
  GSMServiceKind.HTD,
  GSMServiceKind.GAS,
  GSMServiceKind.HQM,
];

/**
 * omniOfferSetupDropdownConfig creates an offer of any of the
 * {@link omniOfferServiceKinds} in an omni process. WRH offers its
 * choices of scope of work service variations, see {@link wrhOfferSetupChoices}; every
 * other kind creates an offer with the scope of works its ruleset sets up
 * by default.
 */
export const omniOfferSetupDropdownConfig: OfferSetupDropdownConfig = {
  choices: omniOfferServiceKinds.flatMap((kind): OfferSetupChoice[] => {
    const prefix = `${kind} – `;
    if (kind === GSMServiceKind.WRH) {
      return wrhOfferSetupChoices(prefix);
    }
    return [
      {
        label: prefix + serviceKindLabel(kind),
        serviceKind: kind,
        scopeOfWorkServiceVariations: [],
      },
    ];
  }),
};
